import { find } from "lodash";
import ApplicationForCandidacyExamForm from "../components/ApplicationForCandidacyExam.js";
import ApplicationForCandidacyExamApprovalForm from "../../Form/components/Approval/ApplicationForCandidacyExam.js";
import * as ApplicationForCandidacyExamData from "../data/ApplicationForCandidacyExam.js";
import * as ApplicationForCertificateCompletionData from "../data/ApplicationForCertificateCompletion.js";
import ApplicationForFinalExamForm from "../components/ApplicationForFinalExam.js";
import ApplicationForFinalExamApprovalForm from "../../Form/components/Approval/ApplicationForFinalExam.js";
import * as ApplicationForFinalExamData from "../data/ApplicationForFinalExam.js";
import ApplicationForProfessionalExamForm from "../components/ApplicationForProfessionalExam.js";
import ApplicationForProfessionalExamApprovalForm from "../../Form/components/Approval/ApplicationForProfessionalExam.js";
import * as ApplicationForProfessionalExamData  from "../data/ApplicationForProfessionalExam.js";
import ApplicationToGraduateForm from "../components/ApplicationToGraduate.js";
import ApplicationToGraduateApprovalForm from "../../Form/components/Approval/ApplicationToGraduate.js";
import * as ApplicationToGraduateData from "../data/ApplicationToGraduate.js";
import CombinedDegreeProgramForm from "../components/CombinedDegreeProgram.js";
import CombinedDegreeProgramApprovalForm from "../../Form/components/Approval/CombinedDegreeProgram.js";
import * as CombinedDegreeProgramData from "../data/CombinedDegreeProgram.js";
import CommitteeAndExamPetitionForm from "../components/CommitteeAndExamPetition.js";
// import CommitteeAndExamPetitionApprovalForm from "../../Form/components/Approval/CommitteeAndExamPetition.js";
import * as CommitteeAndExamPetitionData from "../data/CommitteeAndExamPetition.js";
import DelayOfFinalDocumentForm from "../components/DelayOfFinalDocument.js";
import * as DelayOfFinalDocumentData from "../data/DelayOfFinalDocument.js";
import DualDegreeProgramForm from "../components/DualDegreeProgram.js";
import * as DualDegreeProgramData from "../data/DualDegreeProgram.js";
import GraduateFacultyNominationForm from "../components/GraduateFacultyNomination.js";
import * as GraduateFacultyNominationData from "../data/GraduateFacultyNomination.js";
import LateCoursePetitionForm from "../components/LateCoursePetition.js";
import LateCoursePetitionApprovalForm from "../../Form/components/Approval/LateCoursePetition.js";
import * as LateCoursePetitionData from "../data/LateCoursePetition.js";
import LeaveOfAbsenceFromProgramForm from "../components/LeaveOfAbsenceFromProgram.js";
import * as LeaveOfAbsenceFromProgramData from "../data/LeaveOfAbsenceFromProgram.js"
import * as MinorsAndSpecializationsData from "../data/MinorsAndSpecializations.js"
import ReportForm from "../components/Report.js";
import * as ReportOnFinalDocumentData from "../data/ReportOnFinalDocument.js";
import * as ReportOnFinalExamData from "../data/ReportOnFinalExam.js";
import * as ReportOnCandidacyData from "../data/ReportOnCandidacy.js";
import ReportOnCandidacyApprovalForm from "../../Form/components/Approval/ReportOnCandidacy.js";
import ReportOnFinalExamApprovalForm from "../../Form/components/Approval/ReportOnFinalExam.js";
import SpecializationForm from "../components/Specialization.js";
import * as SpecializationData from "../data/Specialization.js";
import TransferGraduateCreditForm from "../components/TransferGraduateCredit.js";
import * as TransferGraduateCreditData from "../data/TransferGraduateCredit.js";
import WithdrawalFromProgramForm from "../components/WithdrawalFromProgram.js";
import * as WithdrawalFromProgramData from "../data/WithdrawalFromProgram.js"
import { APPLICATION_ROLE, BOOL, formTypeIdentifiers, FORM_TYPE, FORM_TYPE_HTML_FRIENDLY } from "../../util/constants.js"
import { formData, inputMappings } from "../../util/enums";

export const formDefinitions = {
    [FORM_TYPE_HTML_FRIENDLY[formTypeIdentifiers.APPLICATION_FOR_CANDIDACY_EXAM]]: {
        title: FORM_TYPE[formTypeIdentifiers.APPLICATION_FOR_CANDIDACY_EXAM],
        form: ApplicationForCandidacyExamForm,
        sections: ApplicationForCandidacyExamData.formSections,
        approvalForm: ApplicationForCandidacyExamApprovalForm,
        formType: formTypeIdentifiers.APPLICATION_FOR_CANDIDACY_EXAM,
        additionalFilters: ApplicationForCandidacyExamData.additionalFilters,
        getAdminRoles: (form) => ([APPLICATION_ROLE.GRADUATION_ADMIN]),
        isStudentForm: true,
        canCreateForm: (find(formData["graduation-and-examination"].forms, ["name", FORM_TYPE[formTypeIdentifiers.APPLICATION_FOR_CANDIDACY_EXAM]])?.canCreate ?? false),
        formDetailFields: ["oralDate", "academicPlan", "candidacyType", "categoryMApproved"],
        formDetailQuestions: [{ id: "academic-plan", title: "Academic Plan", dataField: "academicPlan" }],
        useUserAcademicPlan: true
    },
    [FORM_TYPE_HTML_FRIENDLY[formTypeIdentifiers.APPLICATION_FOR_CERTIFICATE_COMPLETION]]: {
        title: FORM_TYPE[formTypeIdentifiers.APPLICATION_FOR_CERTIFICATE_COMPLETION],
        sections: ApplicationForCertificateCompletionData.formSections,
        formType: formTypeIdentifiers.APPLICATION_FOR_CERTIFICATE_COMPLETION,
        additionalFilters: ApplicationForCertificateCompletionData.additionalFilters,
        getAdminRoles: (form) => ([APPLICATION_ROLE.GRADUATION_ADMIN]),
        isStudentForm: true,
        canCreateForm: (find(formData["graduation-and-examination"].forms, ["name", FORM_TYPE[formTypeIdentifiers.APPLICATION_FOR_CERTIFICATE_COMPLETION]])?.canCreate ?? false),
        formDetailFields: ["academicPlan", "endOfSemesterOption"]
    },
    [FORM_TYPE_HTML_FRIENDLY[formTypeIdentifiers.APPLICATION_FOR_FINAL_EXAM]]: {
        title: FORM_TYPE[formTypeIdentifiers.APPLICATION_FOR_FINAL_EXAM],
        form: ApplicationForFinalExamForm,
        sections: ApplicationForFinalExamData.formSections,
        approvalForm: ApplicationForFinalExamApprovalForm,
        approvalText: "By clicking on approve, the members of the dissertation or D.M.A. committee judge that the Dissertation/D.M.A. document" +
            " draft of the student named above is of sufficient merit to warrant holding the Final Oral Examination.",
        formType: formTypeIdentifiers.APPLICATION_FOR_FINAL_EXAM,
        additionalFilters: ApplicationForFinalExamData.additionalFilters,
        getAdminRoles: (form) => ([APPLICATION_ROLE.GRADUATION_ADMIN]),
        isStudentForm: true,
        canCreateForm: (find(formData["graduation-and-examination"].forms, ["name", FORM_TYPE[formTypeIdentifiers.APPLICATION_FOR_FINAL_EXAM]])?.canCreate ?? false),
        formDetailFields: ["oralDate", "academicPlan", "finalExamType"]
    },
    [FORM_TYPE_HTML_FRIENDLY[formTypeIdentifiers.APPLICATION_FOR_PROFESSIONAL_EXAM]]: {
        title: FORM_TYPE[formTypeIdentifiers.APPLICATION_FOR_PROFESSIONAL_EXAM],
        form: ApplicationForProfessionalExamForm,
        sections: ApplicationForProfessionalExamData.formSections,
        approvalForm: ApplicationForProfessionalExamApprovalForm,
        formType: formTypeIdentifiers.APPLICATION_FOR_PROFESSIONAL_EXAM,
        additionalFilters: ApplicationForProfessionalExamData.additionalFilters,
        getAdminRoles: (form) => ([APPLICATION_ROLE.GRADUATION_ADMIN]),
        isStudentForm: true,
        canCreateForm: (find(formData["graduation-and-examination"].forms, ["name", FORM_TYPE[formTypeIdentifiers.APPLICATION_FOR_PROFESSIONAL_EXAM]])?.canCreate ?? false),
        formDetailFields: ["examDate", "academicPlan", "professionalExamType", "categoryMApproved"],
        formDetailQuestions: [{ id: "academic-plan", title: "Academic Plan", dataField: "academicPlan" }],
        useUserAcademicPlan: true
    },
    [FORM_TYPE_HTML_FRIENDLY[formTypeIdentifiers.APPLICATION_TO_GRADUATE]]: {
        title: FORM_TYPE[formTypeIdentifiers.APPLICATION_TO_GRADUATE],
        form: ApplicationToGraduateForm,
        sections: ApplicationToGraduateData.formSections,
        approvalForm: ApplicationToGraduateApprovalForm,
        formType: formTypeIdentifiers.APPLICATION_TO_GRADUATE,
        additionalFilters: ApplicationToGraduateData.additionalFilters,
        getAdminRoles: (form) => ([APPLICATION_ROLE.GRADUATION_ADMIN]),
        isStudentForm: true,
        canCreateForm: (find(formData["graduation-and-examination"].forms, ["name", FORM_TYPE[formTypeIdentifiers.APPLICATION_TO_GRADUATE]])?.canCreate ?? false),
        formDetailFields: ["gradLevel", "academicPlan", "gradDegree", "endOfSemesterOption"]
    },
    [FORM_TYPE_HTML_FRIENDLY[formTypeIdentifiers.COMBINED_DEGREE_PROGRAM]]: {
        title: FORM_TYPE[formTypeIdentifiers.COMBINED_DEGREE_PROGRAM],
        form: CombinedDegreeProgramForm,
        sections: CombinedDegreeProgramData.formSections,
        approvalForm: CombinedDegreeProgramApprovalForm,
        type: FORM_TYPE.ENROLLMENT,
        formType: formTypeIdentifiers.COMBINED_DEGREE_PROGRAM,
        additionalFilters: CombinedDegreeProgramData.additionalFilters,
        getAdminRoles: (form) => ([APPLICATION_ROLE.ENROLLMENT_ADMIN]),
        isStudentForm: true,
        canCreateForm: (find(formData["enrollment"].forms, ["name", FORM_TYPE[formTypeIdentifiers.COMBINED_DEGREE_PROGRAM]])?.canCreate ?? false),
        formDetailFields: ["currentCareer", "academicPlan", "recordUpdateComplete"]
    },
    [FORM_TYPE_HTML_FRIENDLY[formTypeIdentifiers.COMMITTEE_AND_EXAM_PETITION]]: {
        title: FORM_TYPE[formTypeIdentifiers.COMMITTEE_AND_EXAM_PETITION],
        form: CommitteeAndExamPetitionForm,
        sections: CommitteeAndExamPetitionData.formSections,
        // approvalForm: CommitteeAndExamPetitionApprovalForm,
        formType: formTypeIdentifiers.COMMITTEE_AND_EXAM_PETITION,
        additionalFilters: CommitteeAndExamPetitionData.additionalFilters,
        getAdminRoles: (form) => ([APPLICATION_ROLE.GRADUATION_ADMIN]),
        isStudentForm: true,
        canCreateForm: (find(formData["graduation-and-examination"].forms, ["name", FORM_TYPE[formTypeIdentifiers.COMMITTEE_AND_EXAM_PETITION]])?.canCreate ?? false),
        formDetailFields: ["academicPlan", "applicationType", "reasonForPetition"]
    },
    [FORM_TYPE_HTML_FRIENDLY[formTypeIdentifiers.DELAY_OF_FINAL_DOCUMENT]]: {
        title: FORM_TYPE[formTypeIdentifiers.DELAY_OF_FINAL_DOCUMENT],
        form: DelayOfFinalDocumentForm,
        sections: DelayOfFinalDocumentData.formSections,
        formType: formTypeIdentifiers.DELAY_OF_FINAL_DOCUMENT,
        getAdminRoles: (form) => ([APPLICATION_ROLE.GRADUATION_ADMIN]),
        isStudentForm: true,
        canCreateForm: (find(formData["graduation-and-examination"].forms, ["name", FORM_TYPE[formTypeIdentifiers.DELAY_OF_FINAL_DOCUMENT]])?.canCreate ?? false),
        formDetailFields: ["gradLevel", "academicPlan", "gradDegree"]
    },
    [FORM_TYPE_HTML_FRIENDLY[formTypeIdentifiers.DUAL_DEGREE_PROGRAM]]: {
        title: FORM_TYPE[formTypeIdentifiers.DUAL_DEGREE_PROGRAM],
        form: DualDegreeProgramForm,
        sections: DualDegreeProgramData.formSections,
        type: FORM_TYPE.ENROLLMENT,
        formType: formTypeIdentifiers.DUAL_DEGREE_PROGRAM,
        getAdminRoles: (form) => ([APPLICATION_ROLE.ENROLLMENT_ADMIN]),
        isStudentForm: true,
        canCreateForm: (find(formData["enrollment"].forms, ["name", FORM_TYPE[formTypeIdentifiers.DUAL_DEGREE_PROGRAM]])?.canCreate ?? false),
        formDetailFields: ["academicPlan"]
    },
    [FORM_TYPE_HTML_FRIENDLY[formTypeIdentifiers.GRAD_FACULTY_NOMINATION]]: {
        title: FORM_TYPE[formTypeIdentifiers.GRAD_FACULTY_NOMINATION],
        form: GraduateFacultyNominationForm,
        sections: GraduateFacultyNominationData.formSections,
        formType: formTypeIdentifiers.GRAD_FACULTY_NOMINATION,
        getAdminRoles: (form) => ([APPLICATION_ROLE.ENROLLMENT_ADMIN, APPLICATION_ROLE.GRADUATION_ADMIN]),
        isStudentForm: false,
        canCreateForm: true,
        contextFields: {
            studentid: "facultyMember.emplid"
        },
        pk: "facultyMember.emplid",
        formDetailFields: ["academicPlan", "proposedCategory", "proposedGradProgram"] // TODO: How to display Graduate Faculty first and last name together?
    },
    [FORM_TYPE_HTML_FRIENDLY[formTypeIdentifiers.LATE_COURSE_PETITION]]: {
        title: FORM_TYPE[formTypeIdentifiers.LATE_COURSE_PETITION],
        form: LateCoursePetitionForm,
        sections: LateCoursePetitionData.formSections,
        approvalForm: LateCoursePetitionApprovalForm,
        type: FORM_TYPE.ENROLLMENT,
        formType: formTypeIdentifiers.LATE_COURSE_PETITION,
        getAdminRoles: (form) => ([APPLICATION_ROLE.ENROLLMENT_ADMIN]),
        isStudentForm: true,
        canCreateForm: (find(formData["enrollment"].forms, ["name", FORM_TYPE[formTypeIdentifiers.LATE_COURSE_PETITION]])?.canCreate ?? false),
        formDetailFields: [ "courseType", "courses.courseSubject", "courses.courseNumber", "courses.courseNumber", "courses.instructor" ],
        useUserAcademicPlan: true
    },
    [FORM_TYPE_HTML_FRIENDLY[formTypeIdentifiers.LEAVE_OF_ABSENCE_FROM_PROGRAM]]: {
        title: FORM_TYPE[formTypeIdentifiers.LEAVE_OF_ABSENCE_FROM_PROGRAM],
        form: LeaveOfAbsenceFromProgramForm,
        sections: LeaveOfAbsenceFromProgramData.formSections,
        formType: formTypeIdentifiers.LEAVE_OF_ABSENCE_FROM_PROGRAM,
        getAdminRoles: (form) => (form?.pcdIndicator === BOOL.YES ? [APPLICATION_ROLE.GRADUATION_ADMIN] : [APPLICATION_ROLE.ENROLLMENT_ADMIN]),
        isStudentForm: true,
        canCreateForm: (find(formData["enrollment"].forms, ["name", FORM_TYPE[formTypeIdentifiers.LEAVE_OF_ABSENCE_FROM_PROGRAM]])?.canCreate ?? false),
        formDetailFields: ["pcdIndicator", "academicPlan", "fromTermCode", "toTermCode"],
        formDetailQuestions: [{
            id: "post-candidacy",
            dataField: "pcdIndicator",
            type: inputMappings.checkbox,
            defaultValue: BOOL.NO,
            choices: [{ id: "yes-post-candidacy", title: "Post-Candidacy", dataField: "pcdIndicator", value: BOOL.YES }]
        }]
    },
    [FORM_TYPE_HTML_FRIENDLY[formTypeIdentifiers.MINORS_AND_SPECIALIZATIONS]]: {
        title: FORM_TYPE[formTypeIdentifiers.MINORS_AND_SPECIALIZATIONS],
        sections: MinorsAndSpecializationsData.formSections,
        formType: formTypeIdentifiers.MINORS_AND_SPECIALIZATIONS,
        additionalFilters: MinorsAndSpecializationsData.additionalFilters,
        getAdminRoles: (form) => ([APPLICATION_ROLE.ENROLLMENT_ADMIN]),
        isStudentForm: true,
        canCreateForm: (find(formData["enrollment"].forms, ["name", FORM_TYPE[formTypeIdentifiers.MINORS_AND_SPECIALIZATIONS]])?.canCreate ?? false),
        formDetailFields: ["concentrationType", "designation"]
    },
    [FORM_TYPE_HTML_FRIENDLY[formTypeIdentifiers.REPORT_ON_CANDIDACY]]: {
        title: FORM_TYPE[formTypeIdentifiers.REPORT_ON_CANDIDACY],
        form: ReportForm,
        sections: ReportOnCandidacyData.formSections,
        approvalForm: ReportOnCandidacyApprovalForm,
        buildApprovalText: (approver) => (
            "The candidacy examination is a single examination consisting of two portions, oral and written. The student is considered to have completed " + 
            "the candidacy examination successfully only when the decision of the candidacy committee is unanimously affirmative. The decision is based " + 
            `on the committee’s evaluation of the entire examination, both written and oral portions. \n\nBy indicating below, I, ${approver.name}, judge ` + 
            "that the student named above satisfactorily or unsatisfactorily completed the candidacy examination."
        ),
        formType: formTypeIdentifiers.REPORT_ON_CANDIDACY,
        additionalFilters: ReportOnCandidacyData.additionalFilters,
        getAdminRoles: (form) => ([APPLICATION_ROLE.GRADUATION_ADMIN]),
        isStudentForm: true,
        canCreateForm: (find(formData["reports"].forms, ["name", FORM_TYPE[formTypeIdentifiers.REPORT_ON_CANDIDACY]])?.canCreate ?? false),
        formDetailFields: ["oralDate"]
    },
    [FORM_TYPE_HTML_FRIENDLY[formTypeIdentifiers.REPORT_ON_FINAL_DOCUMENT]]: {
        title: FORM_TYPE[formTypeIdentifiers.REPORT_ON_FINAL_DOCUMENT],
        form: ReportForm,
        sections: ReportOnFinalDocumentData.formSections,
        buildApprovalText: (approver) => (
            `By indicating below, I, ${approver.name}, judge that the thesis/dissertation/Prof. Doc. document of the student named above is a contribution ` +
            "to knowledge of importance sufficient to warrant its acceptance by the Graduate School in partial fulfillment of the requirements for the degree."
        ),
        formType: formTypeIdentifiers.REPORT_ON_FINAL_DOCUMENT,
        additionalFilters: ReportOnFinalDocumentData.additionalFilters,
        getAdminRoles: (form) => ([APPLICATION_ROLE.GRADUATION_ADMIN]),
        isStudentForm: true,
        canCreateForm: (find(formData["reports"].forms, ["name", FORM_TYPE[formTypeIdentifiers.REPORT_ON_FINAL_DOCUMENT]])?.canCreate ?? false),
        formDetailFields: ["oralDate", "academicPlan"]
    },
    [FORM_TYPE_HTML_FRIENDLY[formTypeIdentifiers.REPORT_ON_FINAL_EXAM]]: {
        title: FORM_TYPE[formTypeIdentifiers.REPORT_ON_FINAL_EXAM],
        form: ReportForm,
        sections: ReportOnFinalExamData.formSections,
        approvalForm: ReportOnFinalExamApprovalForm,
        buildApprovalText: (approver) => (
            "The student is considered to have successfully completed the final examination only when the decision of the examination committee is unanimously affirmative.\n\n" + 
            `By indicating below, I, ${approver.name}, judge that the student named above satisfactorily or unsatisfactorily completed the final examination.`
        ),
        formType: formTypeIdentifiers.REPORT_ON_FINAL_EXAM,
        additionalFilters: ReportOnFinalExamData.additionalFilters,
        getAdminRoles: (form) => ([APPLICATION_ROLE.GRADUATION_ADMIN]),
        isStudentForm: true,
        canCreateForm: (find(formData["reports"].forms, ["name", FORM_TYPE[formTypeIdentifiers.REPORT_ON_FINAL_EXAM]])?.canCreate ?? false),
        formDetailFields: ["oralDate", "academicPlan"]
    },
    [FORM_TYPE_HTML_FRIENDLY[formTypeIdentifiers.REPORT_ON_PROF_EXAM]]: {
        title: FORM_TYPE[formTypeIdentifiers.REPORT_ON_PROF_EXAM],
        form: ReportForm,
        sections: ApplicationForProfessionalExamData.formSections,
        buildApprovalText: (approver) => (
            "The student is considered to have successfully completed the professional examination only when the decision of the examination committee is unanimously affirmative.\n\n" + 
            `By indicating below, I, ${approver.name}, judge that the student named above satisfactorily or unsatisfactorily completed the professional examination.`
        ),
        formType: formTypeIdentifiers.REPORT_ON_PROF_EXAM,
        additionalFilters: ApplicationForProfessionalExamData.additionalFilters,
        getAdminRoles: (form) => ([APPLICATION_ROLE.GRADUATION_ADMIN]),
        isStudentForm: true,
        canCreateForm: (find(formData["reports"].forms, ["name", FORM_TYPE[formTypeIdentifiers.REPORT_ON_PROF_EXAM]])?.canCreate ?? false),
        formDetailFields: ["examDate", "examDate", "professionalExamType"]
    },
    [FORM_TYPE_HTML_FRIENDLY[formTypeIdentifiers.SPECIALIZATION]]: {
        title: FORM_TYPE[formTypeIdentifiers.SPECIALIZATION],
        sections: SpecializationData.formSections,
        formType: formTypeIdentifiers.SPECIALIZATION,
        getAdminRoles: (form) => ([APPLICATION_ROLE.ENROLLMENT_ADMIN, APPLICATION_ROLE.GRADUATION_ADMIN]),
        isStudentForm: false,
        // canCreateForm: (find(formData["enrollment"].forms, ["name", FORM_TYPE[formTypeIdentifiers.SPECIALIZATION]])?.canCreate ?? false),
        canCreateForm: true,
        contextFields: {
            studentid: "osuid.emplid"
        },
        formDetailFields: ["specialization"]
    },
    [FORM_TYPE_HTML_FRIENDLY[formTypeIdentifiers.TRANSFER_GRADUATE_CREDIT]]: {
        title: FORM_TYPE[formTypeIdentifiers.TRANSFER_GRADUATE_CREDIT],
        form: TransferGraduateCreditForm,
        sections: TransferGraduateCreditData.formSections,
        type: FORM_TYPE.ENROLLMENT,
        formType: formTypeIdentifiers.TRANSFER_GRADUATE_CREDIT,
        additionalFilters: TransferGraduateCreditData.additionalFilters,
        getAdminRoles: (form) => ([APPLICATION_ROLE.ENROLLMENT_ADMIN]),
        isStudentForm: true,
        canCreateForm: (find(formData["enrollment"].forms, ["name", FORM_TYPE[formTypeIdentifiers.TRANSFER_GRADUATE_CREDIT]])?.canCreate ?? false),
        formDetailFields: ["creditType", "academicPlan"]
    },
    [FORM_TYPE_HTML_FRIENDLY[formTypeIdentifiers.WITHDRAWAL_FROM_PROGRAM]]: {
        title: FORM_TYPE[formTypeIdentifiers.WITHDRAWAL_FROM_PROGRAM],
        form: WithdrawalFromProgramForm,
        sections: WithdrawalFromProgramData.formSections,
        type: FORM_TYPE.ENROLLMENT,
        formType: formTypeIdentifiers.WITHDRAWAL_FROM_PROGRAM,
        getAdminRoles: (form) => (form?.pcdIndicator === BOOL.YES ? [APPLICATION_ROLE.GRADUATION_ADMIN] : [APPLICATION_ROLE.ENROLLMENT_ADMIN]),
        isStudentForm: true,
        canCreateForm: (find(formData["enrollment"].forms, ["name", FORM_TYPE[formTypeIdentifiers.WITHDRAWAL_FROM_PROGRAM]])?.canCreate ?? false),
        formDetailFields: ["academicPlan"]
    }
}

export const links = Object.keys(formDefinitions).map(id => {
    return {
        path: `/forms/${id}`,
        title: formDefinitions[id].title
    }
})

const getFormByType  = (type) => {
    const entries = Object.values(formDefinitions)
    const form = entries.find(form => form.formType === type)

    return form
}

const getCsvFormDetailFieldsSet = () => {
    const arrayOfFormDetailCsvFields = [
        "fromTermCode", "toTermCode", "termCode", "academicPlan", "gradLevel", "gradDegree", "commencement", "endOfSemesterOption",
        "lastUpdatedDate", "examDate.start", "requestGradFacultyRep", "candidacyType", "professionalExamType", "finalExamType", "draftDissertationTitle",
        "formatReviewComplete", "submittedDate", "reasonForPetition", "oralDate.start"
    ]
    const setOfCsvFormDetailFields = new Set(arrayOfFormDetailCsvFields);
    return setOfCsvFormDetailFields;
}

export { 
    formDefinitions as default,
    getFormByType,
    getCsvFormDetailFieldsSet
}
